import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const StatusToast = ({ message, onClose }) => {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onClose, 5000);
    return () => clearTimeout(t);
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div
      className="fixed top-20 right-4 z-50 flex items-center gap-3 px-4 py-3 rounded-xl shadow-2xl"
      style={{
        background: 'rgba(15,23,42,0.95)',
        border: '1px solid rgba(20,184,166,0.4)',
        backdropFilter: 'blur(16px)',
        maxWidth: '340px',
        animation: 'slideInRight 0.3s cubic-bezier(0.34,1.56,0.64,1)',
      }}
    >
      <div
        className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
        style={{ background: 'rgba(20,184,166,0.15)', border: '1px solid rgba(20,184,166,0.3)' }}
      >
        <Icon name="Bell" size={14} color="#14B8A6" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold" style={{ color: '#14B8A6', fontFamily: 'DM Sans, sans-serif' }}>Status Updated</p>
        <p className="text-xs mt-0.5" style={{ color: 'rgba(255,255,255,0.6)' }}>{message}</p>
      </div>
      <button
        onClick={onClose}
        className="flex-shrink-0 opacity-50 hover:opacity-100 transition-opacity"
        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
      >
        <Icon name="X" size={13} color="rgba(255,255,255,0.6)" />
      </button>
      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default StatusToast;
